import axios from 'axios';
import api from './api';

interface LoginCredentials {
    username: string;
    password: string;
}

interface RegisterData {
    username: string;
    email: string;
    password: string;
    firstname: string;
    lastname: string;
}

class AuthService {
    async login(credentials: LoginCredentials) {
        try {
            const response = await api.post('/auth/login', {
                username: credentials.username,
                password: credentials.password
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace('/login');
                return;
            }
            console.error('Login error:', error);
            throw error;
        }
    }

    async logout() {
        await api.post('/auth/logout');
    }

    async checkAuth() {
        try {
            await api.get('/auth/check');
            return true;
        } catch (error) {
            return false;
        }
    }

    async register(data: RegisterData) {
        const response = await api.post('/auth/register', data);
        return response.data;
    }
}

export const authService = new AuthService(); 